<template>
    <div>
        <div class="row" id="productList">
            <div class="col-lg-2 col-md-3 no-l-padd">
                <Aside v-if="filtersData"
                       v-model="filtersValue"
                       :data="filtersData"
                       @onChangeFilters="onChangeFilters" />
            </div>
            <div class="col-lg-10 col-md-9 list-box">
                <BreadCrumbs :categoryId="categoryId" />

                <Grid v-if="!loading"
                      :listOptions="listOptions"
                      :gridData="searchResult"
                      :totalCount="totalCount"
                      :resultLoading="resultLoading"
                      :comparisonList="comparisonList"
                      :compareLimitation="compareLimitation"
                      @onChangeListOptions="onChangeListOptions"
                      @onAddToComparisonList="addToComparisonList"
                      @onRmoveFromComparisonList="removeFromComparisonList" />
            </div>

            <!-- Loading -->
            <div class="pro-list-loading" v-if="loading" v-bind:style="{ top: loadingCssTop }">
                <div class="container">
                    <div class="row">
                        <div class="col-lg-2 col-md-3 no-l-padd">
                            <div class="list--isloading h-100">
                                <div class="loading-image h-100"></div>
                            </div>
                        </div>
                        <div class="col-lg-10 col-md-9 no-l-padd">
                            <div class="row no-margin">
                                <div class="col-sm-6 col-md-4 col-sm-3 no-r-padd" v-for="index in 8" :key="index">
                                    <div class="list--isloading">
                                        <div class="loading-image"></div>
                                        <div class="loading-content">
                                            <div class="loading-btn"></div>
                                            <div class="loading-text-container">
                                                <div class="loading-main-text"></div>
                                                <div class="loading-sub-text"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- End Loading -->
        </div>

        <ComparisonList v-if="comparisonList && comparisonList.length"
                        v-model="comparisonList"
                        :limitCount="compareLimitation"
                        @onRemoveItem="removeFromComparisonList"
                        @onClearComparisonList="clearComparisonList" />
    </div>
</template>

<script>
    import Vue from 'vue';
    import { mapGetters, mapActions } from 'vuex';
    import BreadCrumbs from './_components/breadCrumbs';
    import Aside from './_components/aside';
    import Grid from './_components/grid';
    import ComparisonList from './_components/comparisonList';
    import Utils from '@/utilities/utils';
    import { PRODUCT_LIST_CONSTANTS } from '@/constants/constants.js';
    import { PRODUCT_LIST_PATHS } from '@/constants/storePaths.js';

    const DEFAULT_FILTERS_VALUE = {
        brands: undefined,
        colors: undefined,
        name: undefined,
        isAvailable: undefined,
        minPrice: undefined,
        maxPrice: undefined
    };
    const DEFAULT_LIST_OPTIONS = {
        pageNo: 1,
        pageSize: PRODUCT_LIST_CONSTANTS.defaultPageSize,
        sort: PRODUCT_LIST_CONSTANTS.defaultSortId
    };

    export default Vue.extend({
        components: { BreadCrumbs, Aside, Grid, ComparisonList },
        data() {
            return {
                filtersData: null,
                filtersValue: {},
                listOptions: {},
                categoryName: null,
                categoryId: null,
                totalCount: null,
                searchResult: [],
                loading: true,
                resultLoading: false,
                currentQueryOptions: undefined,
                comparisonList: [],
                lastApiRequest: null,
                dontUpdateUrl: true,
                loadingCssTop: '155px'
            };
        },
        computed: {
            compareLimitation: () => PRODUCT_LIST_CONSTANTS.maxCountOfComparisonList
        },
        beforeMount() {
            var comparisonCookie = this.$cookie.get('comparisonList' + this.$route.params.id);
            if (comparisonCookie) this.comparisonList = JSON.parse(comparisonCookie);

            window.addEventListener('popstate', this.onBrowserButtonsClick, false);

            this.readOptionsFromUrl();
        },
        mounted() {
            this.fetchFilterPanel({
                menuId: this.categoryId,
                contractId: PRODUCT_LIST_CONSTANTS.defaultContractId
            }).then((data) => {
                this.filtersData = data;
            });
            this.dontUpdateUrl = true;
            this.search();
        },
        beforeDestroy() {
            window.removeEventListener('popstate', this.onBrowserButtonsClick);
        },
        methods: {
            ...mapActions({
                fetchProductList: PRODUCT_LIST_PATHS.fetchProductList,
                fetchFilterPanel: PRODUCT_LIST_PATHS.fetchFilterPanel
            }),
            onBrowserButtonsClick(data) {
                this.loading = true;
                this.readOptionsFromUrl();
                this.dontUpdateUrl = true;
                this.search();
            },
            onChangeFilters() {
                this.resultLoading = true;
                this.search();
            },
            onChangeListOptions(options) {
                this.resultLoading = true;
                this.listOptions = options;
                this.search();
            },
            search() {
                var self = this;

                self.updateUrl();

                var queryOptions = {
                    name: this.filtersValue.name,
                    isAvailable: this.filtersValue.isAvailable,
                    minPrice: this.filtersValue.minPrice,
                    maxPrice: this.filtersValue.maxPrice,
                    orderType: this.listOptions.sort,
                    take: this.listOptions.pageSize,
                    skip: (this.listOptions.pageNo - 1) * this.listOptions.pageSize,
                    menuId: this.categoryId,
                    contractId: PRODUCT_LIST_CONSTANTS.defaultContractId
                };
                var queryParams = Utils.toQueryString(queryOptions);

                if (this.filtersValue.brands)
                    this.filtersValue.brands.forEach((element) => {
                        queryParams += `&brandIds=${element}`;
                    });
                if (this.filtersValue.colors)
                    this.filtersValue.colors.forEach((element) => {
                        queryParams += `&colorIds=${element}`;
                    });

                if (this.lastApiRequest === queryParams) {
                    self.loading = false;
                    self.resultLoading = false;
                    return;
                }
                this.lastApiRequest = queryParams;

                self.fetchProductList({ queryParams }).then((result) => {
                    self.totalCount = result.data.total;
                    self.searchResult = result.data.data;
                    self.loading = false;
                    self.resultLoading = false;
                });
            },
            readOptionsFromUrl() {
                this.dontUpdateUrl = true;
                this.categoryId = parseInt(this.$route.params.id);
                this.categoryName = this.$route.params.id;
                this.filtersValue = { ...DEFAULT_FILTERS_VALUE };
                this.listOptions = { ...DEFAULT_LIST_OPTIONS };

                if (Object.keys(this.$route.query).length) {
                    this.dontUpdateUrl = true;
                    this.filtersValue = Object.assign(this.filtersValue, {
                        brands:
                            typeof this.$route.query.brands === 'string'
                                ? [this.$route.query.brands]
                                : this.$route.query.brands,
                        colors:
                            typeof this.$route.query.colors === 'string'
                                ? [this.$route.query.colors]
                                : this.$route.query.colors,
                        name: this.$route.query.name,
                        isAvailable: this.$route.query.isAvailable,
                        minPrice: this.$route.query.minPrice,
                        maxPrice: this.$route.query.maxPrice
                    });
                    this.listOptions = Object.assign(this.listOptions, {
                        pageNo: this.$route.query.pageNo && parseInt(this.$route.query.pageNo),
                        pageSize: this.$route.query.pageSize && parseInt(this.$route.query.pageSize),
                        sort: this.$route.query.sort && parseInt(this.$route.query.sort)
                    });
                }
            },
            updateUrl() {
                var queryOptions = {
                    ...this.filtersValue,
                    ...this.listOptions
                };
                if (
                    JSON.stringify(queryOptions) ===
                    JSON.stringify({ ...DEFAULT_FILTERS_VALUE, ...DEFAULT_LIST_OPTIONS })
                )
                    queryOptions = undefined;

                if (JSON.stringify(this.currentQueryOptions) === JSON.stringify(queryOptions)) {
                    this.dontUpdateUrl = false;
                    return;
                }

                this.currentQueryOptions = queryOptions
                    ? {
                        ...queryOptions
                    }
                    : undefined;

                if (this.dontUpdateUrl) {
                    this.dontUpdateUrl = false;
                    return;
                }

                this.$router.push({ path: `/category/${this.categoryName}`, query: this.currentQueryOptions });
            },
            addToComparisonList(data) {
                if (this.comparisonList.length === PRODUCT_LIST_CONSTANTS.maxCountOfComparisonList) {
                    this.$swal({
                        text: `حداکثر امکان مقایسه ${PRODUCT_LIST_CONSTANTS.maxCountOfComparisonList} محصول وجود دارد!`,
                        icon: 'error',
                        showConfirmButton: false,
                    });
                    return;
                }
                this.comparisonList.push(data);
                this.setComparisonListCookie();
                this.$swal({
                    toast: true,
                    position: 'center',
                    icon: 'success',
                    title: 'محصول مورد نظر به لیست مقایسه اضافه شد.',
                    showConfirmButton: false,
                    timer: 1500
                });
            },
            removeFromComparisonList(productId) {
                this.comparisonList = this.comparisonList.filter((product) => product.actualProductId !== productId);
                this.setComparisonListCookie();
                this.$swal({
                    toast: true,
                    position: 'center',
                    icon: 'error',
                    title: 'محصول مورد نظر از لیست مقایسه حذف شد.',
                    showConfirmButton: false,
                    timer: 1500
                });
            },
            clearComparisonList() {
                this.comparisonList = [];
                this.setComparisonListCookie();
            },
            setComparisonListCookie() {
                this.$cookie.set(
                    'comparisonList' + this.categoryId,
                    JSON.stringify(this.comparisonList),
                    PRODUCT_LIST_CONSTANTS.comparisonCookieExpirsionPeriod
                );
            }
        }
    });
</script>
